import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationHelper } from '../helpers/authenticationHelper';
import { UtilityHelper } from '../helpers/utilityHelper';
import { shouldRedirectToWaitingListFromStorage } from '../helpers/openAccessWaitingList.helper';

/**
 * WaitingListGuard
 *
 * Allows access to the waiting-list page only for logged-in mentee users on
 * Open Access projects that have reached user capacity.
 */
@Injectable()
export class WaitingListGuard implements CanActivate {

    constructor(
        private authService: AuthenticationHelper,
        private utility: UtilityHelper,
        private router: Router
    ) {}

    canActivate(): boolean {
        const isLoggedIn = this.authService.isLoggedIn();

        if (isLoggedIn && shouldRedirectToWaitingListFromStorage(this.utility)) {
            return true;
        }

        this.router.navigate(['']);
        return false;
    }
}
